// Generated by purs version 0.14.3
"use strict";
var Control_Alt = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/control/v5.0.0/src/Control/Alt.purs");
var Control_Alternative = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/control/v5.0.0/src/Control/Alternative.purs");
var Control_Applicative = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Applicative.purs");
var Control_Apply = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Apply.purs");
var Control_Bind = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Bind.purs");
var Control_Category = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Category.purs");
var Control_Monad = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Monad.purs");
var Control_Monad_Reader_Trans = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Reader/Trans.purs");
var Control_Monad_Writer = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Writer.purs");
var Control_MonadPlus = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/control/v5.0.0/src/Control/MonadPlus.purs");
var Control_Plus = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/control/v5.0.0/src/Control/Plus.purs");
var Control_Semigroupoid = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Semigroupoid.purs");
var Data_Function = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Function.purs");
var Data_Functor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Functor.purs");
var Data_Functor_Invariant = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/invariant/v5.0.0/src/Data/Functor/Invariant.purs");
var Data_Newtype = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/newtype/v4.0.0/src/Data/Newtype.purs");
var Data_Profunctor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/profunctor/v5.0.0/src/Data/Profunctor.purs");
var Data_Profunctor_Star = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/profunctor/v5.0.0/src/Data/Profunctor/Star.purs");
var Data_Tuple = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/tuples/v6.0.1/src/Data/Tuple.purs");
var GCodec = (function () {
    function GCodec(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    GCodec.create = function (value0) {
        return function (value1) {
            return new GCodec(value0, value1);
        };
    };
    return GCodec;
})();
var semigroupoidGCodec = function (dictBind) {
    return new Control_Semigroupoid.Semigroupoid(function (v) {
        return function (v1) {
            return new GCodec(v.value0, Control_Semigroupoid.compose(Data_Profunctor_Star.semigroupoidStar(dictBind))(v.value1)(v1.value1));
        };
    });
};
var profunctorGCodec = function (dictFunctor) {
    return function (dictFunctor1) {
        return new Data_Profunctor.Profunctor(function (f) {
            return function (g) {
                return function (v) {
                    return new GCodec(Data_Functor.map(dictFunctor)(g)(v.value0), Data_Profunctor.dimap(Data_Profunctor_Star.profunctorStar(dictFunctor1))(f)(g)(v.value1));
                };
            };
        });
    };
};
var mapCodec = function (dictBind) {
    return function (f) {
        return function (g) {
            return function (v) {
                var enc = function (a) {
                    var v1 = Control_Monad_Writer.runWriter(Data_Newtype.un()(Data_Profunctor_Star.Star)(v.value1)(g(a)));
                    return Control_Monad_Writer.writer(new Data_Tuple.Tuple(a, v1.value1));
                };
                var dec = function (x) {
                    return Control_Bind.bindFlipped(dictBind)(f)(Control_Monad_Reader_Trans.runReaderT(v.value0)(x));
                };
                return new GCodec(dec, enc);
            };
        };
    };
};
var functorGCodec = function (dictFunctor) {
    return function (dictFunctor1) {
        return new Data_Functor.Functor(function (f) {
            return function (v) {
                return new GCodec(Data_Functor.map(dictFunctor)(f)(v.value0), Data_Functor.map(Data_Profunctor_Star.functorStar(dictFunctor1))(f)(v.value1));
            };
        });
    };
};
var invariantGCodec = function (dictFunctor) {
    return function (dictFunctor1) {
        return new Data_Functor_Invariant.Invariant(Data_Functor_Invariant.imapF(functorGCodec(dictFunctor)(dictFunctor1)));
    };
};
var encoder = function (v) {
    return v.value1;
};
var encode = function (c) {
    var $102 = Data_Newtype.un()(Data_Profunctor_Star.Star)(encoder(c));
    return function ($103) {
        return Control_Monad_Writer.execWriter($102($103));
    };
};
var decoder = function (v) {
    return v.value0;
};
var decode = function ($104) {
    return Control_Monad_Reader_Trans.runReaderT(decoder($104));
};
var composeCodec = function (dictBind) {
    return function (v) {
        return function (v1) {
            return new GCodec(function (x) {
                return Control_Bind.bindFlipped(dictBind)(Control_Monad_Reader_Trans.runReaderT(v.value0))(Control_Monad_Reader_Trans.runReaderT(v1.value0)(x));
            }, function (c) {
                var v2 = Control_Monad_Writer.runWriter(Data_Newtype.un()(Data_Profunctor_Star.Star)(v.value1)(c));
                return Control_Monad_Writer.writer(new Data_Tuple.Tuple(v2.value0, Control_Monad_Writer.execWriter(Data_Newtype.un()(Data_Profunctor_Star.Star)(v1.value1)(v2.value1))));
            });
        };
    };
};
var composeCodecFlipped = function (dictBind) {
    return Data_Function.flip(composeCodec(dictBind));
};
var codec = function (dec) {
    return function (enc) {
        return new GCodec(dec, function (x) {
            return Control_Monad_Writer.writer(enc(x));
        });
    };
};
var bihoistGCodec = function (f) {
    return function (g) {
        return function (v) {
            return new GCodec(f(v.value0), function ($105) {
                return g(v.value1($105));
            });
        };
    };
};
var hoistCodec = function (f) {
    return bihoistGCodec(Control_Monad_Reader_Trans.mapReaderT(f))(Control_Category.identity(Control_Category.categoryFn));
};
var basicCodec = function (f) {
    return function (g) {
        return new GCodec(f, function (x) {
            return Control_Monad_Writer.writer(new Data_Tuple.Tuple(x, g(x)));
        });
    };
};
var applyGCodec = function (dictApply) {
    return function (dictApply1) {
        return new Control_Apply.Apply(function () {
            return functorGCodec(dictApply.Functor0())(dictApply1.Functor0());
        }, function (v) {
            return function (v1) {
                return new GCodec(Control_Apply.apply(dictApply)(v.value0)(v1.value0), Control_Apply.apply(Data_Profunctor_Star.applyStar(dictApply1))(v.value1)(v1.value1));
            };
        });
    };
};
var bindGCodec = function (dictBind) {
    return function (dictBind1) {
        return new Control_Bind.Bind(function () {
            return applyGCodec(dictBind.Apply0())(dictBind1.Apply0());
        }, function (v) {
            return function (f) {
                return new GCodec(Control_Bind.bind(dictBind)(v.value0)(function ($106) {
                    return decoder(f($106));
                }), Control_Bind.bind(Data_Profunctor_Star.bindStar(dictBind1))(v.value1)(function ($107) {
                    return encoder(f($107));
                }));
            };
        });
    };
};
var applicativeGCodec = function (dictApplicative) {
    return function (dictApplicative1) {
        return new Control_Applicative.Applicative(function () {
            return applyGCodec(dictApplicative.Apply0())(dictApplicative1.Apply0());
        }, function (x) {
            return new GCodec(Control_Applicative.pure(dictApplicative)(x), Control_Applicative.pure(Data_Profunctor_Star.applicativeStar(dictApplicative1))(x));
        });
    };
};
var monadGCodec = function (dictMonad) {
    return function (dictMonad1) {
        return new Control_Monad.Monad(function () {
            return applicativeGCodec(dictMonad.Applicative0())(dictMonad1.Applicative0());
        }, function () {
            return bindGCodec(dictMonad.Bind1())(dictMonad1.Bind1());
        });
    };
};
var altGCodec = function (dictAlt) {
    return function (dictAlt1) {
        return new Control_Alt.Alt(function () {
            return functorGCodec(dictAlt.Functor0())(dictAlt1.Functor0());
        }, function (v) {
            return function (v1) {
                return new GCodec(Control_Alt.alt(dictAlt)(v.value0)(v1.value0), Control_Alt.alt(Data_Profunctor_Star.altStar(dictAlt1))(v.value1)(v1.value1));
            };
        });
    };
};
var plusGCodec = function (dictPlus) {
    return function (dictPlus1) {
        return new Control_Plus.Plus(function () {
            return altGCodec(dictPlus.Alt0())(dictPlus1.Alt0());
        }, new GCodec(Control_Plus.empty(dictPlus), Control_Plus.empty(Data_Profunctor_Star.plusStar(dictPlus1))));
    };
};
var alternativeGCodec = function (dictAlternative) {
    return function (dictAlternative1) {
        return new Control_Alternative.Alternative(function () {
            return applicativeGCodec(dictAlternative.Applicative0())(dictAlternative1.Applicative0());
        }, function () {
            return plusGCodec(dictAlternative.Plus1())(dictAlternative1.Plus1());
        });
    };
};
var monadPlusGCodec = function (dictMonadPlus) {
    return function (dictMonadPlus1) {
        return new Control_MonadPlus.MonadPlus(function () {
            return alternativeGCodec(dictMonadPlus.Alternative1())(dictMonadPlus1.Alternative1());
        }, function () {
            return monadGCodec(dictMonadPlus.Monad0())(dictMonadPlus1.Monad0());
        });
    };
};
module.exports = {
    GCodec: GCodec,
    decoder: decoder,
    encoder: encoder,
    bihoistGCodec: bihoistGCodec,
    codec: codec,
    decode: decode,
    encode: encode,
    mapCodec: mapCodec,
    composeCodec: composeCodec,
    composeCodecFlipped: composeCodecFlipped,
    hoistCodec: hoistCodec,
    basicCodec: basicCodec,
    functorGCodec: functorGCodec,
    invariantGCodec: invariantGCodec,
    applyGCodec: applyGCodec,
    applicativeGCodec: applicativeGCodec,
    bindGCodec: bindGCodec,
    monadGCodec: monadGCodec,
    profunctorGCodec: profunctorGCodec,
    altGCodec: altGCodec,
    plusGCodec: plusGCodec,
    alternativeGCodec: alternativeGCodec,
    monadPlusGCodec: monadPlusGCodec,
    semigroupoidGCodec: semigroupoidGCodec
};

